import { create } from 'zustand';
import apiClient from '../service/apiClient';
import { Page } from '../type/type';
import { toast } from 'react-toastify';

export interface IConsultRequestItem {
  id: string;
  name: string;
  phoneNumber: string;
  birthDate?: string;
  birthTime?: string;
  solarType?: string;
  sex?: string;
  trkId: string;
  campaignName?: string;
  franchiseName?: string;
  createdAt: string;
  updatedAt: string;
}

interface ConsultRequestResponse extends Page {
  content: IConsultRequestItem[];
}

type ConsultRequestState = {
  resultList: IConsultRequestItem[];
  resultPage: Page | null;
  loading: boolean;
};

type ConsultRequestAction = {
  fetchResults: (
    startDt?: string,
    endDt?: string,
    name?: string,
    phoneNumber?: string,
    page?: number,
    size?: number
  ) => Promise<void>;
};

export const useConsultRequestStore = create<
  ConsultRequestState & ConsultRequestAction
>(set => ({
  resultList: [],
  resultPage: null,
  loading: false,

  fetchResults: async (
    startDt,
    endDt,
    name,
    phoneNumber,
    page = 0,
    size = 20
  ) => {
    set({ loading: true });
    try {
      const response = await apiClient.get<ConsultRequestResponse>(
        '/consult-order/request',
        {
          params: {
            startDt,
            endDt,
            name: name || undefined,
            phoneNumber: phoneNumber || undefined,
            page,
            size,
            sort: 'createdAt,desc',
          },
        }
      );
      const { content, ...rest } = response.data;
      set({ resultList: content, resultPage: rest });
    } catch (error) {
      console.error(error);
      toast.error('신청내역을 조회하지 못했습니다.');
    }
    set({ loading: false });
  },
}));
